/**
 * What IT last said on a ticket, for the "Waiting on you" banner (9 Oct).
 *
 * LIVE SR 10661: the requester saw "IT needs something from you" and could not
 * find what. The banner now quotes IT's latest public note, so the question is
 * on screen where the person is told to answer it.
 *
 * Only IT's own words count: an `AGENT` entry that is a note (COMMENT or
 * INFO_REQUESTED) with text. The requester's comments, status changes and
 * notification emails are skipped, whatever order they came in.
 */

import type { TicketTimelineEntry } from "../api/contract";

const IT_NOTE_KINDS = new Set(["COMMENT", "INFO_REQUESTED"]);

export function isItNote(entry: TicketTimelineEntry): boolean {
  return (
    entry.actor.kind === "AGENT" &&
    IT_NOTE_KINDS.has(entry.kind) &&
    entry.body != null &&
    entry.body.text.trim() !== ""
  );
}

/** IT's most recent public note, or null when there is none. */
export function latestItNote(entries: readonly TicketTimelineEntry[]): TicketTimelineEntry | null {
  let latest: TicketTimelineEntry | null = null;
  for (const entry of entries) {
    if (!isItNote(entry)) {
      continue;
    }
    if (latest === null || Date.parse(entry.occurred_at) > Date.parse(latest.occurred_at)) {
      latest = entry;
    }
  }
  return latest;
}
